module.exports = __webpack_public_path__ + "static/media/vet.f5aa9908.svg";